import ParticleWavesAnimation from "components/animations/ParticleWaves";

export default function AuthLayout(p: { children: React.ReactNode }) {
  return (
    <>
      <ParticleWavesAnimation />

      <div className="relative flex min-h-screen flex-col items-center justify-center">
        {p.children}
      </div>
    </>
  );
}
